import { Page } from "./page";

export class Why extends Page
{
    public icon : string
}